import { render, staticRenderFns } from "./AdministratorsSelector.vue?vue&type=template&id=34de4ef4&"
import script from "./AdministratorsSelector.vue?vue&type=script&lang=js&"
export * from "./AdministratorsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports